<template>
  <!-- DELETE-BUTTON -->
  <span>
    <b-button
      v-b-modal.delete
      class="mt-1"
      variant="danger"
      size="sm"
    >
      {{ $t('message.datasetDetails.delete') }}
    </b-button>

    <b-modal
      id="delete"
      :title="getID"
      ok-title="Delete"
      @ok="deleteDataSet"
    >
      <p class="my-4">
        Are you sure you want to delete this item?
      </p>
    </b-modal>
  </span>
</template>

<script>
// Import Actions and Getters from Store Module
import { mapGetters } from 'vuex';
// Import components used in template
import AppLink from './AppLink';
import { normalize } from '@/utils/helpers';
/* eslint-disable */
export default {
  name: 'EDP2-datasetDetailsDeleteButton',
  dependencies: ['uploadService'],
  components: {
    appLink: AppLink,
  },
  data() {
    return {
      error: '',
      catalog: '',
    };
  },
  computed: {
    // import store-getters
    ...mapGetters('datasetDetails', [
      'getID',
      'getLanguages',
      'getTitle',
      'getCatalog',
    ]),
    ...mapGetters('auth', [
      'securityAuth'
    ]),
  },
  methods: {
    /* eslint-disable */
    deleteDataSet() {
      // normalizing dataset ID (as per torben jastrow 17/07/2019)
      let datasetId = this.normalize(this.getID);
      // delete dataset API call
      this.$Progress.start();
      this.$keycloak.getRtpToken()
        .then((rtpToken) => {
          return this.uploadService.deleteDistribution(datasetId, this.getCatalog.id, rtpToken.data.access_token);
        })
        .then((res) => {
          // redirect to home page
          this.$router.push({ name: 'Catalogues' });
          // this.$router.go(0);
          this.$Progress.finish();
        })
        .catch((ex) => {
          this.$Progress.fail();
        })
    },
    normalize,
  },
};
</script>

<style lang="scss" scoped>
button {
  margin: 0 5px;
}
</style>
